import * as Entities from '../constants/entities';
import { EntityStatuses, StatusDisplayNames, Statuses } from '../constants/statuses';

export function isValidEntity(entity) {
  return !!Object.values(Entities).includes(entity);
}

export function isValidStatusForEntity(entity, status) {
  if (!isValidEntity(entity)) {
    throw new Error(`Invalid entity ${entity}`);
  }

  return EntityStatuses[entity].includes(status);
}

export function getStatusDisplayName(status) {
  return StatusDisplayNames[status];
}

export function getStatusFilterSelectOptions(entity, displayTextSuffix = '') {
  if (!isValidEntity(entity)) {
    throw new Error(`Invalid entity ${entity}`);
  }

  return EntityStatuses[entity]
    .map(status => ({ value: status, text: `${StatusDisplayNames[status]}${displayTextSuffix}` }));
}

export const getProjectStatusFromRequirementStatus = status => {
  if ([Statuses.Approved, Statuses.Compliant, Statuses.Waived].includes(status)) {
    return Statuses.Approved;
  }

  return Statuses.Archived === status ? status : Statuses.NotApproved;
};
